import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=074c164c&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=074c164c&prod&lang=scss&scoped=true"
import style1 from "./ImageView.vue?vue&type=style&index=1&id=074c164c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c164c",
  null
  
)

export default component.exports